import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { RespectMode } from "@nju/feature-portal-orchestrator";
import { DashboardCancelOrderPage } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function CancelOrder() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RespectMode mode={["ftth", "mobile", "postpaid", "fsecure"]}>
          {({ mode }) => {
            return (
              <RequiredDashboardData extendedMode={mode}>
                <Navigation />
                <DashboardCancelOrderPage mode={mode} />
              </RequiredDashboardData>
            );
          }}
        </RespectMode>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
